// material-ui
import { useTheme } from '@mui/material/styles';
import React, { useState, useEffect } from 'react';

import {
  Box,
  Grid,
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Typography,
  Divider,
  Alert,
  Backdrop,
  CircularProgress,
  Tooltip,
  IconButton,
  Pagination
} from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV2';
import axios from 'src/utils/axios';
import PrintIcon from '@mui/icons-material/Print';
import ExcelFileCreator from 'src/components/ExcelFileCreator';

// ==============================|| PROFILE 1 - CHANGE PASSWORD ||============================== //

const styles = {
  ul: {
    '& .MuiPaginationItem-root': {
      '&.Mui-selected': {
        background: '#FF9800',
        color: 'white',
        borderRadius: '50%',
      },
    },
  },
  backdrop: (theme) => ({
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  }),
  responsiveContainer: (theme) => ({
    marginTop: theme.spacing(3),
    [theme.breakpoints.between('md', 'lg')]: {
      maxHeight: '70vh',
      overflowX: 'hidden',
      overflowY: 'scroll'
    },
    [theme.breakpoints.down('sm')]: {
      maxHeight: '60vh',
      overflow: 'scroll'
    }
  }),
};

const EmployeeHistory = ({ EmployeeNr }) => {
  const theme = useTheme();

  if (EmployeeNr === 0) {
    return (
      <Grid container spacing={2}>
        <Grid
          size={{
            xs: 12,
            sm: 12,
            md: 12
          }}>
          <Alert variant="outlined" severity="error" sx={{ borderColor: theme.palette.warning.dark }}>
            <Typography variant='h5' style={{ color: 'red' }}>Önce Kayıt İşlemini Tamamlamanız Gerekli!....
            </Typography>
          </Alert>      </Grid>
      </Grid>
    );
  }
  const [historyData, setHistoryData] = useState([]);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [OrganizationControl, setOrganizationControl] = useState('0');
  const itemsPerPage = 5;

  useEffect(() => {
    setLoading(true);
    axios.get(`GetTechnicianHistory/${EmployeeNr}`)
      .then((response) => {
        setLoading(false);
        if (response?.data.length > 0) {
          setHistoryData(response.data);
          setOrganizationControl(response.data[0]?.teknisyenNo);
        } else {
          setHistoryData([]);
        }
      });
  }, []);


  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const handleExportClick = () => {
    var exportData = [];
    historyData?.map((item) => {
      exportData.push({
        "Eleman No": item.ElemanNo,
        "Sicil No": item.SicilNo,
        "Teknisyen No": item.TeknisyenKodu,
        "Ad": item.Ad,
        "Soyad": item.Soyad,
        "İlk İşe Giriş Tarihi": item.İlkİseGirişTarihi,
        "İlgili İşe Giriş Tarihi": item.İlgiliİseGirişTarihi,
        "Ayrılış Tarihi": item.AyrilisTarihi,
        "Birim Kodu - Birim": item.Servis,
        "Log Tarihi": item.LogTarihi,
        "Aciklama": item.Aciklama,
        "Kullanıcı": item.DegisiklikYapan
      });
    });

    ExcelFileCreator(exportData, `${EmployeeNr} - Tarihçe`);
  };


  // Mevcut sayfadaki verileri al
  const startIndex = (page - 1) * itemsPerPage;
  const endIndex = page * itemsPerPage;
  const paginatedData = historyData?.slice(startIndex, endIndex);
  return (
    <>
      {
        loading ?
          <Backdrop sx={styles.backdrop} open={loading}>
            <CircularProgress color="inherit" />
          </Backdrop>
          : ''
      }
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid>
            <Typography variant="h5">Tarihçe</Typography>
          </Grid>
          <Grid>
            <Pagination
              count={Math.ceil(historyData?.length / itemsPerPage)}
              page={page}
              onChange={handlePageChange}
              variant="outlined"
              sx={styles.ul}
            />
          </Grid>
          <Grid>
            <Tooltip title="Yazdır">
              <IconButton size="large" onClick={handleExportClick}>
                <PrintIcon />
              </IconButton>
            </Tooltip>
          </Grid>
        </Grid>
        <Divider sx={{ mb: 2 }} />
        <Box sx={{ maxHeight: 400, overflowY: 'auto' }}>
              <TableContainer >
                <Table stickyHeader aria-label="sticky table" size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell>Eleman No</TableCell>
                      <TableCell>Sicil No</TableCell>
                      {OrganizationControl !== '-1' ? <TableCell>Teknisyen No</TableCell> : ''}
                      <TableCell>Ad</TableCell>
                      <TableCell>Soyad</TableCell>
                      <TableCell>İlk İşe Giriş Tarihi</TableCell>
                      <TableCell>İlgili İşe Giriş Tarihi</TableCell>
                      <TableCell>Ayrılış Tarihi</TableCell>
                      <TableCell>Birim Kodu - Birim</TableCell>
                      <TableCell>Log Tarihi</TableCell>
                      <TableCell>Açıklama</TableCell>
                      <TableCell>Degisiklik Yapan</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {historyData.slice((page - 1) * itemsPerPage, page * itemsPerPage).map((item) => (
                      <TableRow key={item.id}>
                        <TableCell>{item.ElemanNo}</TableCell>
                        <TableCell>{item.SicilNo}</TableCell>
                        {item.TeknisyenKodu !== "-1" ? <TableCell>{item.TeknisyenKodu}</TableCell> : ''}
                        <TableCell>{item.Ad}</TableCell>
                        <TableCell>{item.Soyad}</TableCell>
                        <TableCell>{item.İlkİseGirişTarihi}</TableCell>
                        <TableCell>{item.İlgiliİseGirişTarihi}</TableCell>
                        <TableCell>{item.AyrilisTarihi}</TableCell>
                        <TableCell>{item.Servis}</TableCell>
                        <TableCell>{item.LogTarihi}</TableCell>
                        <TableCell>{item.Aciklama}</TableCell>
                        <TableCell>{item.DegisiklikYapan}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
        </Box>
      </LocalizationProvider>
    </>
  );
};

export default EmployeeHistory;
